import { useEffect, useState } from 'react';
import { BankAccountApi } from '@recargas-dominicanas/core/api';
import { DetailItem } from '@recargas-dominicanas/core/components';
import { type IPendingTransaction } from '@recargas-dominicanas/core/types';
import { formatCurrency, formatDate, useField } from '@recargas-dominicanas/core/utils';
import { BusinessSelect } from '../../../../components/business-select/business-select.component';
import { BankAccountStore } from '../../../../store/bankAccountStore';
import { Modal } from '../../../../components/modal/modal.component';
import { EditField } from '../edit-field/edit-field.component';
import { style } from './register-pending-deposit-modal.module.css';

interface Props {
  open: boolean;
  bankAccountId: number;
  pendingTransaction: IPendingTransaction;
  onClose: () => void;
}

export function RegisterPendingDepositModal(props: Props) {

  const {
    open,
    bankAccountId,
    pendingTransaction,
    onClose
  } = props;

  const businessField = useField('');
  const [disabled, setDisabled] = useState(false);
  const [error, setError] = useState<string>();
  const [description, setDescription] = useState('');

  useEffect(() => {
    setDescription(pendingTransaction.description || '');
  }, [open, pendingTransaction.description]);

  async function handleRegister() {
    
    try {

      setDisabled(true);
      setError(undefined);

      const businessId = businessField.value ? parseInt(businessField.value) : undefined;
      const customDescription = description && description !== pendingTransaction.description ? description : undefined;

      await BankAccountApi.registerPendingDeposit(bankAccountId, pendingTransaction.id, businessId, customDescription);
      
      BankAccountStore.fetchById(bankAccountId);
      BankAccountStore.fetchPendingTransactions(bankAccountId, 1, 25);

      handleClose();

    } catch {

      setDisabled(false);
      setError('Error registrando deposito');
    }
  }

  function handleClose() {
    onClose();
    businessField.clear();
    setDisabled(false);
    setError(undefined);
  }

  return (
    <Modal
      open={open}
      style={style.modal}
      title='Registrar deposito'
      error={error}
      secondaryButton='Registrar'
      disabledSecondaryButton={disabled}
      onClose={handleClose}
      onSecondaryClick={handleRegister}>
      <span className={style.selectTitle}>Negocio</span>
      <BusinessSelect
        className={style.businessSelect}
        icon='storefront'
        placeholder='Seleccionar negocio'
        field={businessField}/>
      <span className={style.transactionTitle}>Transacción</span>
      <DetailItem
        style={style.detailItem}
        title='Monto'
        color='green'
        weight='medium'
        text={formatCurrency(pendingTransaction.balance)}/>      
      <DetailItem
        style={style.detailItem}
        title='Fecha'
        text={formatDate(pendingTransaction.date)}/>
      <DetailItem
        style={style.detailItem}
        title='Fecha de creación'
        text={formatDate(pendingTransaction.creationDate)}/>      
      {pendingTransaction.reference &&
        <DetailItem
          style={style.detailItem}
          title='Referencia'
          text={pendingTransaction.reference}/>      
      }
      <EditField
        title='Descripción'
        placeholder='Agregar descripción'
        value={description}
        onChange={value => setDescription(value)}/>
    </Modal>
  );
}
